<template>
  <div class="table-content">
    <!-- 数据为空的状态 -->
    <Empty v-if="isEmpty" />

    <div v-else>
      <!-- 搜索栏部分 -->
      <ul class="flex flex-wrap justify-start mt-4 items-center h-8">
        <li class="mr-3 mb-4">
          <el-input v-model="forms.surveyTitle" placeholder="请输入问卷标题" clearable @keyup.enter.native="searchWJ"></el-input>
        </li>
        <li class="mr-3 mb-4">
          <el-input v-model="forms.agentName" placeholder="请输入委托公司" clearable @keyup.enter.native="searchWJ"></el-input>
        </li>
        <li class="select mr-3 mb-4">
          <el-select v-model="forms.taskStatus" placeholder="全部" class="w-32 h-8" clearable>
            <el-option :label="item" :value="index" v-for="(item, index) in TASK_STATUS" :key="index"></el-option>
          </el-select>
        </li>
        <li class="mr-3 mb-4">
          <el-button type="primary" size="small" @click="searchWJ">查询</el-button>
        </li>
        <li class="mr-3 mb-4">
          <el-button size="small" @click="handlerReset">重置</el-button>
        </li>
      </ul>
      <div v-for="item in tableData" class="w-full box mt-4 box-border">
        <div class="header flex items-center w-full">
          <div class="company text-small rounded-small text-white px-2">
            {{ item.agentName }}
          </div>
          <div class="surveyName text-medium-x flex-1">
            {{ item.surveyTitle }}
          </div>
          <el-button class="text-medium-x text-theme mr-4" type="text" @click="viewTask(item, item.children[0])">查看</el-button>
        </div>

        <data-table
          cell-class-name="truncate-table-cell-wrap"
          align="left"
          @size-change="handlerSize"
          @pagination-current-change="handlerCurrent"
          :data="item.children"
          :columns="columns"
          :page="page"
          :loading="tableLoading"
          :showPage="false"
          class="px-4"
        >
          <!-- 结算方式 -->
          <template #settleMode="{ row }">
            <p v-if="row.settleMode == '1'">按答卷结算</p>
            <p v-if="row.settleMode == '2'">按天结算</p>
            <p v-if="row.settleMode == '3'">按阶梯结算</p>
          </template>

          <!-- 数量 -->
          <template #expectedQuantity="{ row }">
            <p v-if="row.settleRule && row.settleMode == '1'">{{ row.settleRule.expectedQuantity }} 份</p>
            <p v-if="row.settleRule && row.settleMode == '2'">{{ row.settleRule.expectedQuantity }} 天</p>
            <p v-if="row.settleRule && row.settleMode == '3'">{{ row.settleRule.expectedQuantity }} 天</p>
          </template>

          <!-- 单价 -->
          <template #unitPriceYuan="{ row }">
            <p v-if="row.settleRule && row.settleMode == '1'">{{ row.settleRule.unitPriceYuan }}元/份</p>
            <p v-if="row.settleRule && row.settleMode == '2'">{{ row.settleRule.unitPriceYuan }}元/天</p>
            <p v-if="row.settleRule && row.settleMode == '3'">
              {{ row.settleRule.tiers[0].unitPriceYuan }}元{{
                row.settleRule.tiers.length > 1
                  ? '~' + row.settleRule.tiers[row.settleRule.tiers.length - 1].unitPriceYuan + '元'
                  : ''
              }}/份
              <el-tooltip
                popper-class="unit-price-tooltip"
                effect="light"
                :content="tooltipText(row.settleRule.tiers)"
                placement="top"
              >
                <!-- <i class="iconfont">&#xe63d;</i> -->
                <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer text-medium"></i>
              </el-tooltip>
            </p>
          </template>

          <!-- 任务状态 -->
          <template #surveyStatus="{ row }">
            <div class="flex justify-start">
              <p class="w-2 h-2 rounded-full mt-2 mr-1 bg-green-theme" v-if="row.surveyStatusCode === 0"></p>
              <p class="w-2 h-2 rounded-full mt-2 mr-1 bg-theme-text-gray" v-if="row.surveyStatusCode === 1"></p>
              <p>{{ row.surveyStatus }}</p>
            </div>
          </template>

          <!-- 是否承接 -->
          <template #taskStatus="{ row }">
            <p v-if="row.taskStatus === 3">待承接</p>
            <p v-else-if="row.taskStatus === 4">已承接</p>
            <p v-else-if="row.taskStatus === 5">已拒接</p>
            <p v-else-if="row.taskStatus === 6">已关闭</p>
            <p v-else-if="row.taskStatus === 7">已完成</p>
          </template>

          <!-- 操作 -->
          <template #operation="{ row }">
            <el-button type="text" @click="viewTask(item, row)">查看</el-button>
            <el-button v-if="row.taskStatus === 3 && row.surveyStatusCode === 0" type="text" @click="accept(row.taskId)"
              >承接</el-button
            >
            <el-button
              v-if="row.taskStatus === 3 && row.surveyStatusCode === 0"
              class="text-danger"
              type="text"
              @click="refuse(row.taskId)"
              >拒接</el-button
            >
          </template>
        </data-table>
      </div>
      <!-- 网站协议文案提示 -->
      <DygcFooter class="mt-2" v-custom:home="'out_D19_1'" />
      <el-pagination
        @size-change="handlerSize"
        @current-change="handlerCurrent"
        :current-page.sync="page.currentPage"
        :page-sizes="page.pageSizes"
        :page-size.sync="page.pageSize"
        :total="page.total"
        :layout="'total, sizes, prev, pager, next, jumper'"
        :pager-count="5"
      >
      </el-pagination>
    </div>

    <div class="proxy-dialog">
      <!-- 拒接弹出框 -->
      <el-dialog title="拒接确认" :visible.sync="refuseDialogVisible" width="30%">
        <div>
          <div class="mb-3">确认后，您将不能再参与此任务，此操作不可撤销。确认取消吗？</div>
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入拒接原因,最多输入255个字"
            maxlength="255"
            v-model="refuseReason"
            class="pb-8"
          >
          </el-input>
          <span slot="footer" class="dialog-footer flex justify-end">
            <el-button size="small" @click="refuseDialogVisible = false">取 消</el-button>
            <el-button size="small" type="danger" @click="refuseSure">拒 接</el-button>
          </span>
        </div>
      </el-dialog>

      <!-- 承接弹出框 -->
      <el-dialog title="承接确认" :visible.sync="acceptDialogVisible" width="30%">
        <span>确认后，需要开始执行此任务，此操作不可撤销。确认承接吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="acceptDialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="acceptSure">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Empty from './Empty.vue'
import DataTable from '@/components/base/DataTable'
import { TASK_STATUS } from '@/global/config-variable'
import { myTakeOn, acceptTask } from '@/api/wenjuan/wjmyentrust'
import DygcFooter from 'components/dygc-footer-bottom/index'
export default {
  name: 'table-content',
  components: { Empty, DataTable, DygcFooter },
  data() {
    return {
      TASK_STATUS,
      isEmpty: false,
      isSearch: false,
      searchParams: '',
      forms: {
        surveyTitle: '',
        agentName: '',
        taskStatus: ''
      },
      tableData: [],
      page: {
        currentPage: 1,
        pageSizes: [10, 20, 30, 40, 50, 100],
        total: 0,
        pageSize: 20,
        layout: 'total, prev, pager, next, jumper'
      },
      tableLoading: false,
      columns: [
        {
          label: '任务名称',
          value: 'taskName',
          width: '250px'
        },
        {
          label: '委托时间',
          value: 'inviteTime',
          width: '144px'
        },
        {
          label: '结算方式',
          value: 'settleMode',
          width: '70px'
        },
        {
          label: '数量',
          value: 'expectedQuantity',
          width: '42px'
        },
        {
          label: '单价',
          value: 'unitPriceYuan',
          width: '107px'
        },
        {
          label: '任务状态',
          value: 'surveyStatus',
          width: '56px'
        },
        {
          label: '是否承接',
          value: 'taskStatus',
          width: '56px'
        },
        {
          label: '操作',
          value: 'operation',
          width: '116px'
        }
      ],
      dialogVisible: false,
      rejectedOptions: [
        {
          name: '拒接时间：',
          prop: 'refuseTime'
        },
        {
          name: '拒接原因：',
          prop: 'refuseReason'
        },
        {
          name: '拒接人：',
          prop: 'refusePersonName'
        }
      ],
      closedOptions: [
        {
          name: '关闭时间：',
          prop: 'closingDate'
        },
        {
          name: '关闭前状态：',
          prop: 'taskStatus'
        }
      ],
      refuseReason: '', // 拒接任务对话框的文本域内容
      refuseTaskId: '', // 拒接任务ID
      acceptTaskId: '', // 承接任务ID
      refuseDialogVisible: false, // 拒接任务对话框
      acceptDialogVisible: false // 承接任务对话框
    }
  },
  methods: {
    tooltipText(tiers) {
      let content = '每天'
      if (tiers.length > 1) {
        tiers.forEach(item => {
          content += `${item.quantityLowerBound + 1}份 ~ ${item.quantityUpperBound}份，${item.unitPriceYuan}元/份
        ` //换行显示
        })
      } else {
        content += `${tiers[0].unitPriceYuan}元/份`
      }
      return content
    },
    // 搜索栏事件
    searchWJ() {
      this.isSearch = true
      let params = {
        surveyTitle: this.forms.surveyTitle.trim(),
        agentName: this.forms.agentName.trim(),
        current: this.page.currentPage,
        size: this.page.pageSize
      }
      if (this.forms.taskStatus) params.taskStatus = this.forms.taskStatus //新版按任务状态搜索
      this.searchParams = params
      this.getData(this.searchParams)
    },
    // 重置按钮
    handlerReset() {
      this.isSearch = false
      this.searchParams = ''
      this.forms = {
        surveyTitle: '',
        agentName: '',
        taskStatus: ''
      }
      this.getData()
    },
    // 拒接任务
    refuse(taskId) {
      this.refuseTaskId = taskId
      this.refuseDialogVisible = true
    },
    // 拒接任务对话框关闭提交事件(确定)
    refuseSure() {
      if (this.refuseReason.length > 255) {
        this.$message.error('拒接原因超出字数限制，请重新输入!')
        return
      }
      let params = {
        taskId: this.refuseTaskId,
        flag: 1,
        refuseReason: this.refuseReason
      }
      acceptTask(params).then(res => {
        if (res.status == 200) {
          this.$message({
            message: '拒接任务成功！',
            type: 'success'
          })
        }
        this.acceptTaskId = ''
        this.refuseReason = ''
        this.refuseDialogVisible = false
        this.dialogVisible = false
        this.getData()
      })
    },
    // 承接任务
    accept(taskId) {
      this.acceptTaskId = taskId
      this.acceptDialogVisible = true
    },
    // 承接任务对话框承接(确定)
    acceptSure() {
      let params = {
        taskId: this.acceptTaskId,
        flag: 0,
        refuseReason: ''
      }
      acceptTask(params).then(res => {
        if (res.status == 200) {
          this.$message({
            message: '承接任务成功！',
            type: 'success'
          })
        }
        this.acceptTaskId = ''
        this.acceptDialogVisible = false
        this.dialogVisible = false
        this.getData()
      })
    },
    //查看任务
    viewTask(item, row) {
      // this.$store.commit('SET_PROXY_STORE', 'proxy')
      sessionStorage.setItem('agentName', item.agentName)
      let surveyId = item.surveyId
      if (row.taskStatus === 3 || row.taskStatus === 5) {
        this.$router.cachePush({
          path: `/entrust-proxy/${surveyId}/proxy-task/list/task-details`,
          query: { taskId: row.taskId, agentTenantId: item.agentTenantId }
        })
      } else if (row.taskStatus === 4) {
        this.$router.cachePush({
          path: `/entrust-proxy/${surveyId}/proxy-task/list/investigator-list`,
          query: { taskId: row.taskId, agentTenantId: item.agentTenantId }
        })
      }
    },
    // 修改当前页
    async handlerCurrent(val) {
      if (this.isSearch) {
        this.searchParams.current = val
      } else this.page.currentPage = val
      await this.getData()
      this.$nextTick(() => {
        //翻页后滚动条复原
        document.getElementById('proxySurveyId').scrollTop = 0
      })
    },
    // 修改当前页数量
    handlerSize(val) {
      if (this.isSearch) {
        this.searchParams.size = val
        this.searchParams.current = 1
      } else {
        this.page.pageSize = val
        this.page.currentPage = 1
      }
      this.getData()
    },
    // 获取数据
    getData(params) {
      return new Promise((resolve, reject) => {
        {
          if (this.isSearch) {
            params = this.searchParams
          }
          this.tableLoading = true
          let p = null
          let obj = {
            current: this.page.currentPage,
            size: this.page.pageSize
          }
          if (!params) {
            p = Object.assign({}, obj)
          } else {
            p = Object.assign({}, params)
          }
          myTakeOn(p)
            .then(res => {
              this.tableData = this.getSurveyList(res.data.data.records)
              this.page.total = res.data.data.total
              this.page.currentPage = res.data.data.current
              this.page.pageSize = res.data.data.size
              // 是否显示空状态
              if (this.tableData.length === 0 && !this.isSearch) {
                this.isEmpty = true
              }
              this.tableLoading = false
              resolve()
            })
            .catch(err => {
              console.log(err)
              reject(err)
            })
        }
      })
    },
    // 处理数据
    getSurveyList(data) {
      let children = {}
      let newData = []
      data.forEach(item => {
        //任务存在再处理
        if (item.taskId) {
          //新建属性名
          if (Object.keys(children).indexOf(item.surveyId) === -1) {
            newData.push({
              surveyId: item.surveyId,
              agentName: item.tenantIdName,
              agentTenantId: item.agentTenantId,
              surveyTitle: item.surveyTitle,
              children: []
            })
            children[item.surveyId] = []
          }
          //对应插入children属性值
          children[item.surveyId].push(item)
        }
      })
      newData.forEach(item => {
        item.children = children[item.surveyId]
      })
      return newData
    }
  },
  created() {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.table-content {
  height: 100%;
}
.box {
  border: 1px solid #d8d8d8;
  @apply rounded-small w-full;
}
.header {
  height: 53px;
  border-radius: 0 0 1px 1px;
  @apply bg-card-bg-gray;
  .company {
    line-height: 22px;
    margin-left: 15px;
    @apply leading-22 bg-yellow-theme;
  }
  .surveyName {
    height: 22px;
    margin-left: 4px;
    @apply leading-22;
  }
}
.table-content {
  .el-pagination {
    height: 42px;
    @apply my-4 box-border float-right pr-0 pt-0;
  }
}
</style>
<style lang="scss">
.unit-price-tooltip {
  white-space: pre-line;
}
.proxy-dialog {
  .el-dialog__body {
    padding-top: 10px;
  }
}
</style>
